/**
 * computeSliderMove
 * @elementWidth : size of the moved element
 * @parentWidth : size of wrapper element
 * @currentPosition :  current position of the moved element
 * @direction : direction the slider will move (-1 or 1)
 * @increment : the maximum distance the slider will move
 */
export const computeSliderNextPosition = ({
    elementWidth,
    parentWidth,
    currentPosition,
    direction,
    increment = 450,
    firstElementInSliderWidth = 0,
    lastElementInSliderWidth = 0,
}) => {
    if (
        [elementWidth, parentWidth, currentPosition, direction].some(
            v => v === undefined,
        )
    )
        return {
            position: 0,
            limits: {
                left: 0,
                right: 0,
            },
        };
    const limitLeft = 0;
    const limitRight = Math.round((elementWidth - parentWidth) * -1);
    let position = currentPosition + direction * increment;
    position =
        position + direction * firstElementInSliderWidth > limitLeft
            ? limitLeft
            : position;
    position =
        position + direction * lastElementInSliderWidth < limitRight
            ? limitRight
            : position;

    return {
        position,
        limits: {
            left: limitLeft,
            right: limitRight,
        },
    };
};

export default {
    computeSliderNextPosition,
};
